import template from './managerYearInline.html';
import controller from './managerYearInline.controller';
import './managerYearInline.scss';

let managerYearInlineComponent = {
  restrict: 'E',
  bindings: {
    employeeFilters: '<',
    periodFilters: '<',
    calendarLines: '<',
    onChangeDate: '&',
    onInception: '&',
    isDisabled: '<',
    onYearPaginationChanges: '&'
  },
  template,
  controller,
};

export default managerYearInlineComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendar/managerYearInline/managerYearInline.component.js